import React from "react";
import { useNavigate } from "react-router";

export const Contact = (props) => {
  const navigate = useNavigate();

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="section-title">
            <h2>Kontakt</h2>
            {
              //  <p>
              //    Please fill out the form below to send us an email and we will
              //    get back to you as soon as possible.
              //  </p>
            }

            {
              <div className="contact-cards">
                <div className="contact-card col-md-4">
                  <h3>
                    <i className="fa fa-map-marker"> </i> Adresse
                  </h3>
                  <p>
                    {props.data
                      ? props.data.street +
                        ", " +
                        props.data.zipcode +
                        " " +
                        props.data.city
                      : "Lädt..."}
                  </p>
                </div>
                <div className="contact-card col-md-4 ">
                  <h3>
                    <i className="fa fa-phone"> </i> Telefon
                  </h3>
                  <p>
                    {props.data ? (
                      <a href={`tel:${props.data.phone}`}>
                        {props.data.phone}
                      </a>
                    ) : (
                      "Lädt..."
                    )}
                  </p>
                  
                 
                </div>
                <div className="contact-card col-md-4">
                  <h3>
                    <i className="fa fa-envelope-o">{""}</i> Email
                  </h3>
                  <p>
                    {props.data ? (
                      <a href={`mailto:${props.data.email}`}>
                        {props.data.email}
                      </a>
                    ) : (
                      "Lädt..."
                    )}
                  </p>
                </div>
              </div>
            }
          </div>

          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  {
              //    <li>
              //    <a href={props.data ? props.data.facebook : "/"}>
              //      <i className="fa fa-facebook"></i>
              //    </a>
              //  </li>
              //  <li>
              //    <a href={props.data ? props.data.twitter : "/"}>
              //      <i className="fa fa-twitter"></i>
              //    </a>
              //  </li>
}
                  <li>
                    <a href={props.data ? props.data.instagram : "/"}>
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
